const LIGHT_APP_THEME = {
  "--color-bg-app": "#f4f6f9",
  "--color-bg-primary": "#f4f6f9",
  "--color-bg-sidebar": "#ffffff",
  "--color-bg-surface": "#ffffff",
  "--color-bg-elevated": "#ffffff",
  "--color-bg-soft": "#f4f6f9",
  "--color-text-primary": "#1a2235",
  "--color-text-secondary": "#667085",
  "--color-border": "#e4e8f0",
  "--color-success": "#12b76a",
  "--color-danger": "#f04438",
  "--color-warning": "#f79009",
};

export const THEME_COLORS = {
  sattva: {
    "--color-primary": "#744DFF",
    "--color-secondary": "#4EA1FF",
    "--color-btn-primary": "#744DFF",
    ...LIGHT_APP_THEME,
  },
  tcs: {
    "--color-primary": "#744DFF",
    "--color-secondary": "#4EA1FF",
    "--color-btn-primary": "#744DFF",
    ...LIGHT_APP_THEME,
  },
  default: {
    "--color-primary": "#744DFF",
    "--color-secondary": "#4EA1FF",
    "--color-btn-primary": "#744DFF",
    ...LIGHT_APP_THEME,
  },
};
